<template>
  <div id="myDiv" />
</template>

<script>
export default {
  mounted () {
    const line1 = {
      x: ['X1', 'X2'],
      y: [0, 0],
      type: 'scatter'
    }

    const data = [
      line1
    ]
    const layout = {
      xaxis: {
        showgrid: false
      },
      yaxis: {
        showgrid: false
      }
    }
    Plotly.newPlot('myDiv', data, layout) // eslint-disable-line
  }
}
</script>

<style scoped>

</style>
